'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { apiConfig } from '@/config/api';
import LoadingIndicator from '@/components/common/LoadingIndicator';

const RootRedirect = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (user) {
        navigate('/dashboard');
      } else {
        window.location.href = `${apiConfig.wwwUrl}/signin/`;
      }
    }
  }, [user, loading, navigate]);

  return <LoadingIndicator />;
};

export default RootRedirect;
